module.exports = __webpack_public_path__ + "static/media/660.745b6faa.webp";